import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import { CampaignMembersRouter } from 'assets/js/pages/campaign-settings/campaign-members/CampaignMembersRouter';
import { CampaignTeamSettings } from 'assets/js/pages/campaign-settings/campaign-team/CampaignTeamSettings';
import { TeamNavigation } from 'assets/js/pages/campaign-settings/campaign-team/TeamNavigation';
import { CampaignTeamsRouter } from 'assets/js/pages/campaign-settings/campaign-teams/CampaignTeamsRouter';
import { Route } from 'components/router/Route';

const CampaignTeamRoutes = {
    Teams: 'teams',
    Settings: 'fundraise-settings',
};

const CampaignTeamRouter = () => {
    const match = useRouteMatch();

    return (
        <div className={'grid grid-cols-10 gap-4'}>
            <div className={'col-span-full lg:col-span-2'}>
                <TeamNavigation />
            </div>
            <div className={'col-span-full lg:col-span-8'}>
                <Switch>
                    <Route
                        path={`${match.path}/${CampaignTeamRoutes.Teams}`}
                        component={CampaignTeamsRouter}
                    />
                    <Route
                        path={`${match.path}/${CampaignTeamRoutes.Settings}`}
                        component={CampaignTeamSettings}
                    />
                    <Route path={match.path} component={CampaignMembersRouter} />
                    <Route>
                        <Redirect to={match.url} />
                    </Route>
                </Switch>
            </div>
        </div>
    );
};

export { CampaignTeamRouter };
